export default __webpack_public_path__ + "static/media/rickemorty.4cd5755a.png";